import { formatPhone } from "../location-search-map/formatPhone";

export class MarketingPage {

    private nationalPhoneNumber!: string
    constructor() {
        this.localizationPhoneNumber()
    }
    localizationPhoneNumber() {
        const allPhoneNumberheader = document.querySelectorAll<HTMLAnchorElement>(".find-local.header-phoneno")
        if (allPhoneNumberheader.length === 0) return;
        const franchiseWebLocationId = localStorage.getItem('franchiseWebLocationId')
        const doingBusinessAs = localStorage.getItem('doingBusinessAs')
        const localPhoneNumber = localStorage.getItem('localPhoneNumber')
        if (!doingBusinessAs || !franchiseWebLocationId || !localPhoneNumber) return;
        if (localPhoneNumber.trim()) {
            allPhoneNumberheader.forEach((anchorElement: HTMLAnchorElement) => {
                if (!anchorElement.children[0].textContent) return;
                anchorElement.children[0].textContent = `Call now: ${formatPhone(localPhoneNumber)}`
                anchorElement.href = `tel:${localPhoneNumber}`
            })
        }
        const brandDetailsStore = localStorage.getItem('brandDetails')
        if (!brandDetailsStore) return;
        this.nationalPhoneNumber = (JSON.parse(brandDetailsStore) as { phone: string }).phone
    }

}

if (!(globalThis as any).__MarketingPageListenerAdded) {
    (globalThis as any).__MarketingPageListenerAdded = true;
document.addEventListener('DOMContentLoaded', () => {
    if ((globalThis as any).__MarketingPageInitialized) return;
    const pageTypeElement = document.getElementById('pageType')
    if (!pageTypeElement) return;
    const pageType = pageTypeElement as HTMLInputElement
    (globalThis as any).__MarketingPageInitialized = true;
    const marketingPage = new MarketingPage()
    if (pageType.value === 'Opus 2 Campaign Page Template') {
        marketingPage.localizationPhoneNumber()
    }
})
}